import './bebas-neue/BebasNeue-Bold.ttf';
import './bebas-neue/BebasNeue-Light.ttf';
import './bebas-neue/BebasNeue-Regular.ttf';



// WEBPACK FOOTER //
// ./fonts/index.js